module.exports = __webpack_public_path__ + "media/images/common/3column_product_bg_yyx-21249652b387e8b330d15d3f365a0274.png";